
import { ref, watch, defineComponent } from 'vue';
import MessageCustom from '@/components/MessageCustom.vue';
import { useErrorUtilsSingleton } from '@/common/utils/errorUtilsSingleton';
import { useGtmUtilsSingleton } from '@/common/utils/gtmUtilsSingleton';
import { useNSProtectedStore } from '@/store';
import * as tkSTSL from '@/store/modules/stsLandingModule/treekeys';

export default defineComponent({
  name: 'STSLandingGenericError',
  components: {
    MessageCustom,
  },
  props: {
    getC360AcctsState: {
      required: true,
      type: Object,
    },
    getRXProductInfoState: {
      required: false,
      type: Object,
      default: null,
    },
    numKey: {
      required: true,
      type: String,
    },
  },
  setup(props: any) {
    const store = useNSProtectedStore(tkSTSL.STSLANDINGMODULE);
    const errorUtils = useErrorUtilsSingleton();

    const currC360AcctListErr =
      store.getters[tkSTSL.NS_GET_STSLANDINGMODULE_C360ACCTLISTERRKEY];
    const currRXPRoductInfoErr =
      store.getters[tkSTSL.NS_GET_STSLANDINGMODULE_RXPRODUCTINFOERRKEY];
    const errorMsgId = ref(0);
    const gtm = useGtmUtilsSingleton();

    const storeErr = () => {
      store.dispatch(tkSTSL.NS_ACTION_STSLANDINGMODULE_C360ACCTLISTERRKEY, {
        c360AcctListErrKey: props.getC360AcctsState?.c360AccountListError,
      });
      store.dispatch(tkSTSL.NS_ACTION_STSLANDINGMODULE_RXPRODUCTINFOERRKEY, {
        rxProductInfoErrKey: props.getRXProductInfoState?.rxProductInfoError,
      });
    };

    gtm.trackGTMEvent({
      event: 'error',
      flow: {
        name: 'service troubleshooter',
      },
      page: 'STSLanding',
    });

    watch(
      () => props.getC360AcctsState?.c360AccountListError,
      (newVal: any) => {
        if (errorUtils.isNetworkError(newVal)) {
          if (currC360AcctListErr !== newVal) {
            errorMsgId.value += 1;
          }
        }
      },
      { immediate: true }
    );

    watch(
      () => props.getRXProductInfoState?.rxProductInfoError,
      (newVal: any) => {
        if (errorUtils.isNetworkError(newVal)) {
          if (currRXPRoductInfoErr !== newVal) {
            errorMsgId.value += 1;
          }
        } else if (errorUtils.isRxProductInfoError(newVal)) {
          if (currRXPRoductInfoErr !== newVal) {
            errorMsgId.value += 1;
          }
        }
        // if (newVal) {
        //   if (newVal.length > 1) {
        //     errorMsgId.value += 1;
        //   }
        // }
      },
      { immediate: true }
    );

    return {
      errorMsgId,
      storeErr,
    };
  },
});
